import { action, props } from 'ts-action';
import { WaveId } from '../types/wave.type';
import { SkipHistory } from '../../undo/actions/undo.actions';

export const start = action(
  '[Update] start',
  props<
    { id: WaveId; handle: 'onset' | 'offset'; timestamp: number } & SkipHistory
  >(),
);

export const stop = action('[Update] stop', props<SkipHistory>());

export const setBoundary = action(
  '[Update] setBoundary',
  props<
    {
      id: WaveId;
      boundary: 'onset' | 'offset';
      timestamp: number;
    } & SkipHistory
  >(),
);

export const setMoving = action(
  '[Update] setMoving',
  props<{ id: WaveId; timestamp: number } & SkipHistory>(),
);

export const setTimestamp = action(
  '[Update] setTimestamp',
  props<{ timestamp: number } & SkipHistory>(),
);
